import React from 'react'
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import CreateCondominium from '../components/condominium/CreateCondominium';
import EditCondominium from '../components/condominium/EditCondominium';
import Condominiums from '../components/root/condominium/Condominiums';
import Indicators from '../components/root/indicators/Indicators';
import PayMethods from '../components/root/paymethods/PayMethods';
import RootConfig from '../components/root/config/RootConfig';
import Root from '../components/root/Root';
import Support from '../components/root/support/Support';
import CondominiumStatus from '../components/root/condominium/service/CondominiumStatus';
import CondominiumPayments from '../components/root/condominium/payments/CondominiumPayments';
import useDocTitle from '../helpers/hooks/useDocTitle';
import LegacyRouteRedirect from '../helpers/LegacyRouteRedirect';
import ManagerServicePaymentDetails from '../components/finance/ManagerServicePaymentDetails';
import ExchangeConfig from '../components/root/exchange/ExchangeConfig';
import Notifications from '../components/notifications/Notifications';
import ManagerServicePaymentManual from '../components/finance/ManagerServicePaymentManual';
import RootLead from '../components/root/lead/RootLead';
import AccountDeletionRequests from '../components/root/accountDeletion/AccountDeletionRequests';
import IndicatorsPaymentsProperties from '../components/root/indicators/payments/IndicatorsPaymentsProperties';
import IndicatorsPropertyPayments from '../components/root/indicators/payments/IndicatorsPropertyPayments';
import RootRewards from '../components/root/rewards/RootRewards';
import { REWARDS_ENABLED } from '../helpers/rewardsEnabled';

const RootRoutes = ({ match: { url } }) => {

    document.title = useDocTitle();

    return <Switch>
        <Route path={`${url}`} exact component={Root} />
        <Route path={`${url}/condominiums`} exact component={Condominiums} />
        <Route path={`${url}/indicators`} exact component={Indicators} />
        <Route path={`${url}/indicators/:id/payments/properties`} exact component={IndicatorsPaymentsProperties} />
        <Route path={`${url}/indicators/:id/payments/:property`} exact component={IndicatorsPropertyPayments} />
        <Route path={`${url}/condominiums/create`} exact component={CreateCondominium} />
        <Route path={`${url}/condominiums/:id/edit`} exact component={EditCondominium} />
        <Route path={`${url}/condominiums/:id/service`} exact component={ManagerServicePaymentManual} />

        <Route path={`${url}/condominiums/:id/status`} exact component={CondominiumStatus} />
        <Route path={`${url}/condominiums/:id/payments/:charge`} exact component={CondominiumPayments} />
        <Route path={`${url}/condominiums/:id/payments/:charge/:paymentId(\\d+)`} exact component={ManagerServicePaymentDetails} />

        <Route path={`${url}/exchange`} exact component={ExchangeConfig} />

        <Route path={`${url}/support`} exact component={Support} />
        {/* El soporte por tickets se retiró: cualquier URL de ticket vuelve al centro de soporte. */}
        <Redirect exact from={`${url}/support/create`} to={`${url}/support`} />
        <Redirect exact from={`${url}/support/show/:id`} to={`${url}/support`} />
        <Redirect exact from={`${url}/support/:id(\\d+)`} to={`${url}/support`} />

        <Route path={`${url}/paymethods`} exact component={PayMethods} />
        <Route path={`${url}/notifications`} exact component={Notifications} />

        <Route path={`${url}/config`} exact component={RootConfig} />

        <Route path={`${url}/lead`} exact component={RootLead} />

        <Route path={`${url}/account-deletion`} exact component={AccountDeletionRequests} />

        {REWARDS_ENABLED && <Route path={`${url}/rewards`} exact component={RootRewards} />}

        <LegacyRouteRedirect />
    </Switch>
}
export default withRouter(RootRoutes);;